import { Stack } from "@mui/material";

import { ClientsTable } from "Clients/Components/ClientsTable";
import { NewClientButton } from "Clients/Components/NewClientButton";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ClientsPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Common.Clients)}
      action={<NewClientButton />}
    >
      <Stack spacing={Spacing.L}>
        <ClientsTable />
      </Stack>
    </AuthenticatedLayout>
  );
};
